<template>
    <p-feature-flag
        name="Accounting" 
        redirect
    >
        <p-search-screen
            title="Chart of Accounts"
            ref="searchScreen"
            api-destination="chartofaccounts"
            edit-key="chartOfAccountsId" 
            :filters="filters"
            :fields="fields"
            :filterBy="filterBy"
            add-new-button
        >
            <template v-slot:belowSearch>
                <b-row>
                    <b-col cols="12" sm="4" xl="2">
                        <p-select
                                label="Type"
                                data-type="chartOfAccountsTypes"
                                v-model="filters.chartOfAccountsTypeFilter"
                                addEmptyOption
                            />
                    </b-col>
                    <b-col cols="12" sm="4" xl="2">
                        <p-select
                            label="Category"
                            data-type="chartOfAccountsCategories"
                            v-model="filters.categoryFilter"
                            addEmptyOption
                        />
                    </b-col>
                    <b-col cols="12" sm="4" xl="2">
                        <p-select
                                label="Debit/Credit"
                                data-type="debitOrCreditOptions"
                                v-model="filters.debitCreditFilter"
                                addEmptyOption
                            />
                    </b-col>
                </b-row>
            </template>
        </p-search-screen>
    </p-feature-flag>
</template>

<script>
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            isBusy: false,
            filterName: 'ChartOfAccountsFilter',
            filters: {
                automatic: null,
                perPage: 100,
                sortBy: 'ledgerNumber',
                sortDesc: true,
                chartOfAccountsTypeFilter: null,
                categoryFilter: null,
                debitCreditFilter: null,
                searchBy: 'All'
            },
            filterBy: [
                'All',
                'Ledger Number',
                'Description'
            ],
            fields: [
                {
                    key: 'ledgerNumber',
                    sortable: true,
                    label: 'Ledger Number'
                },
                {
                    key: 'chartOfAccountsType',
                    sortable: true,
                    label: 'Type'
                },
                {
                    key: 'category',
                    sortable: true,
                    label: 'Category'
                },
                {
                    key: 'debitOrCredit',
                    sortable: true,
                    label: 'Debit/Credit'
                },
                {
                    key: 'description',
                    sortable: true,
                    label: 'Description'
                },
                {
                    key: 'chartOfAccountsId',
                    hidden: true
                }
            ]
        };
    }
};
</script>